import React from 'react';

/**
 * A one-series horizontal bar chart whose bars are filters.
 *
 * Magnitude in a single accent hue, value at the bar tip in text ink. Each row
 * is one button (the hit target is the whole row, not the thin bar); the
 * selected row keeps the accent while the rest recede, so the chart doubles as
 * the filter's state. Zero bars stay visible as an empty track — "none" is an
 * answer, not a gap.
 */
function BarList({
  title, items = [], selected = '', onSelect = () => {}, formatLabel = (i) => i.label,
}) {
  const max = Math.max(1, ...items.map((i) => i.count));
  return (
    <div className="bar-list">
      <div className="bar-list-title">{title}</div>
      <ul className="list-unstyled mb-0">
        {items.map((item) => {
          const isSelected = selected === item.key;
          const dimmed = !!selected && !isSelected;
          const label = formatLabel(item);
          let hint = isSelected ? ' · click to clear' : ' · click to filter';
          if (item.disabled) hint = '';
          return (
            <li key={item.key}>
              <button
                type="button"
                className={`bar-list-row${isSelected ? ' is-selected' : ''}${dimmed ? ' is-dimmed' : ''}`}
                onClick={() => onSelect(isSelected ? '' : item.key)}
                aria-pressed={isSelected}
                disabled={item.disabled}
                title={`${label}: ${item.count}${hint}`}
              >
                <span className="bar-list-label text-truncate">{label}</span>
                <span className="bar-list-track">
                  <span
                    className="bar-list-fill"
                    style={{ width: `${item.count ? Math.max(2, (item.count / max) * 100) : 0}%` }}
                  />
                </span>
                <span className="bar-list-value">{item.count}</span>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default BarList;
